<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <div class="title-wrapper mb-4">
            <div>
                <h1 class="title-default">Relatório de Entradas e Saídas por Categoria</h1>
                <p class="welcome-message">
                    <button mat-icon-button type="button" (click)="voltar()" aria-label="Voltar para relatórios de finanças">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    Selecione os filtros abaixo para gerar o relatório detalhado de suas movimentações nas contas financeiras.
                </p>
            </div>
        </div>

        @if (carregandoLookups) {
        <div class="row">
            <div class="col-12 mb-4">
                <app-loading-box [height]="'30'" [width]="'250'" [margin]="'0 0 20px 0'"></app-loading-box>
                <div class="row">
                    <div class="col-12 mb-3">
                        <app-loading-box [height]="'150'"></app-loading-box>
                    </div>
                    <div class="col-md-6 col-12 mb-3">
                        <app-loading-box [height]="'100'"></app-loading-box>
                    </div>
                </div>
            </div>
        </div>
        } @else {

        <section class="section-container filtros-section" [class.filtros-hidden]="!filtrosVisiveis">
            <div class="filtros-heading">
                <div class="filtros-heading-title">
                    <mat-icon>filter_alt</mat-icon>
                    <span>Filtros de pesquisa</span>
                </div>
                <div class="favoritos-toolbar">
                    <mat-form-field appearance="outline" class="favoritos-field" subscriptSizing="dynamic">
                        <mat-label>Filtros favoritos</mat-label>
                        <mat-select [formControl]="$any(form.controls['favoritoSelecionado'])"
                            (selectionChange)="carregarFavoritoSelecionado()">
                            <mat-option [value]="null">Selecionar favorito</mat-option>
                            @for (favorito of favoritos; track favorito.idRelatorioFiltroFavorito) {
                            <mat-option [value]="getFavoritoValue(favorito)">{{ favorito.nome }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    @if (hasFavoritoSelecionado || hasAlgumFiltroPreenchido) {
                    <button type="button" mat-stroked-button class="btn-secondary favoritar-button" (click)="favoritarFiltros()">
                        <mat-icon>{{ hasFavoritoSelecionado ? 'delete' : 'star' }}</mat-icon>
                        {{ hasFavoritoSelecionado ? 'Remover favorito' : 'Favoritar filtros' }}
                    </button>
                    }
                </div>
            </div>

            <form [formGroup]="form" class="filtros-body">
                <div class="row g-3">
                    <div class="col-xl-4 col-lg-5 col-12 border-end-desktop">
                        <div class="d-flex flex-column gap-3 h-100">
                            <div class="field-group mb-0 campo-periodo">
                                <label class="field-caption mb-3">Período de referência</label>
                                @if (exibirModoIntervalo) {
                                <div class="periodo-toggle mb-0">
                                    @for (opcao of periodoOpcoes; track opcao.id) {
                                    <button type="button" class="periodo-chip"
                                        [class.periodo-chip-active]="form.get('modoPeriodo')?.value === opcao.id"
                                        (click)="selecionarModoPeriodo(opcao.id)">
                                        {{ opcao.descricao }}
                                    </button>
                                    }
                                </div>
                                } @else {
                                <p class="periodo-mes-hint">Mês de referência (MM/AAAA). Use os botões para alterar o mês.</p>
                                }
                            </div>

                            <div class="flex-grow-1">
                                @if (!exibirModoIntervalo || isModoMes) {
                                <div class="mes-picker">
                                    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mes-picker-field">
                                        <button matPrefix type="button" mat-icon-button class="mes-nav-btn" (click)="navegarMes(-1)" aria-label="Mês anterior">
                                            <mat-icon>chevron_left</mat-icon>
                                        </button>
                                        <input matInput class="text-center mes-input-fw" formControlName="mesAno"
                                            placeholder="MM/AAAA" (blur)="normalizarMesAno()" autocomplete="off">
                                        <button matSuffix type="button" mat-icon-button class="mes-nav-btn" (click)="navegarMes(1)" aria-label="Próximo mês">
                                            <mat-icon>chevron_right</mat-icon>
                                        </button>
                                    </mat-form-field>
                                </div>
                                } @else {
                                <div class="intervalo-grid">
                                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                        <mat-label>Data Inicial</mat-label>
                                        <input matInput [matDatepicker]="pickerInicio" formControlName="dataInicial"
                                            (input)="onDateInput($event, 'dataInicial')" placeholder="DD/MM/AAAA">
                                        <mat-datepicker-toggle matIconSuffix [for]="pickerInicio"></mat-datepicker-toggle>
                                        <mat-datepicker #pickerInicio></mat-datepicker>
                                    </mat-form-field>
                                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                        <mat-label>Data Final</mat-label>
                                        <input matInput [matDatepicker]="pickerFim" formControlName="dataFinal"
                                            (input)="onDateInput($event, 'dataFinal')" placeholder="DD/MM/AAAA">
                                        <mat-datepicker-toggle matIconSuffix [for]="pickerFim"></mat-datepicker-toggle>
                                        <mat-datepicker #pickerFim></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                }
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-8 col-lg-7 col-12">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Conta financeira</mat-label>
                            <mat-select formControlName="idContaFinanceira">
                                <mat-option [value]="null">Todas as contas</mat-option>
                                @for (conta of contas; track conta.id) {
                                <mat-option [value]="conta.id">{{ conta.descricao }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="filtros-footer">
                    <button type="button" mat-flat-button class="btn-primary" (click)="gerar()"
                        [disabled]="carregandoLookups || carregandoRelatorio">
                        @if (!carregandoRelatorio) {
                        Gerar
                        } @else {
                        <mat-spinner diameter="20"></mat-spinner>
                        }
                    </button>
                </div>
            </form>
        </section>

        @if (carregandoRelatorio) {
        <div class="row">
            <div class="col-12 mb-4">
                <app-loading-box [height]="'48'" [margin]="'0 0 20px 0'"></app-loading-box>
                <app-loading-box [height]="'300'"></app-loading-box>
            </div>
        </div>
        } @else if (consultaGerada && possuiResultados) {

        <section class="toolbar-card">
            <div class="toolbar-actions">
                @if (!filtrosVisiveis) {
                <button type="button" mat-flat-button class="btn-primary" (click)="toggleFiltros()">
                    <mat-icon>tune</mat-icon>
                    Exibir filtros
                </button>
                } @else {
                <button type="button" mat-stroked-button class="btn-secondary" (click)="toggleFiltros()">
                    <mat-icon>tune</mat-icon>
                    Ocultar filtros
                </button>
                }
                <button type="button" mat-stroked-button class="btn-secondary icon-only" (click)="imprimir()"
                    matTooltip="Imprimir" aria-label="Imprimir relatório">
                    <mat-icon>print</mat-icon>
                </button>
                <button type="button" mat-stroked-button class="btn-secondary icon-only" (click)="downloadCsv()"
                    matTooltip="Download CSV" aria-label="Download CSV do relatório">
                    <mat-icon>download</mat-icon>
                </button>
            </div>
        </section>

        <section class="resultado-section">

            <!-- ── Tabelas resumo ── -->
            <article class="tabela-card detalhes-card">
                <div class="detalhes-header">
                    <mat-icon>table_chart</mat-icon>
                    <span>Resumo por categoria</span>
                </div>

                <div class="detalhes-grupo">
                    <div class="detalhes-grupo-header">
                        <span class="detalhes-categoria-nome detalhes-section-title-entradas">Entradas</span>
                        <span class="detalhes-categoria-subtotal subtotal-positivo">{{ formatarMoeda(totalEntradas) }}</span>
                    </div>
                    <table class="detalhes-table detalhes-table-resumo">
                        <thead>
                            <tr>
                                <th>Categoria</th>
                                <th class="text-end">Valor</th>
                                <th class="text-end col-pct">%</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (item of listaEntradas; track item.categoria; let i = $index) {
                            <tr class="categoria-row categoria-row-entrada"
                                [class.categoria-row-expanded]="isCategoriaExpandida('entrada', item.categoria)"
                                (click)="toggleCategoriaExpandida('entrada', item.categoria)">
                                <td>
                                    <span class="categoria-cell-inner">
                                        <button type="button" class="btn-cat-collapse"
                                            [attr.aria-label]="isCategoriaExpandida('entrada', item.categoria) ? 'Recolher' : 'Expandir'"
                                            (click)="$event.stopPropagation(); toggleCategoriaExpandida('entrada', item.categoria)">
                                            <mat-icon>{{ isCategoriaExpandida('entrada', item.categoria) ? 'expand_less' : 'expand_more' }}</mat-icon>
                                        </button>
                                        <span class="cat-color-dot" [style.background]="chartColor(i)"></span>
                                        {{ item.categoria }}
                                    </span>
                                </td>
                                <td class="text-end valor-receita">{{ formatarMoeda(item.valor) }}</td>
                                <td class="text-end col-pct pct-cell">{{ item.percentual | abnt: 'quantidade': 1 }}%</td>
                            </tr>
                            @if (isCategoriaExpandida('entrada', item.categoria)) {
                            <tr class="categoria-expansao-row categoria-expansao-entrada" [style.--categoria-color]="chartColor(i)">
                                <td colspan="3">
                                    <table class="detalhes-table detalhes-table-drill">
                                        <thead>
                                            <tr>
                                                <th class="col-data">Data</th>
                                                <th>Descrição</th>
                                                <th class="text-end">Valor</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            @for (mov of getMovimentacoesCategoria('entrada', item.categoria); track mov.idMovimentacao) {
                                            <tr>
                                                <td class="col-data">{{ formatarData(mov.dataMovimentacao) }}</td>
                                                <td class="col-descricao">{{ stripHtml(mov.descricao) }}</td>
                                                <td class="text-end col-valor valor-receita">{{ formatarMoeda(mov.valor) }}</td>
                                            </tr>
                                            }
                                            @if (getMovimentacoesCategoria('entrada', item.categoria).length === 0) {
                                            <tr><td colspan="3" class="detalhes-empty">Sem lançamentos para esta categoria.</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            }
                            }
                            @if (listaEntradas.length === 0) {
                            <tr><td colspan="3" class="detalhes-empty">Nenhuma entrada no período</td></tr>
                            }
                        </tbody>
                        <tfoot>
                            <tr>
                                <td><strong>Total de Entradas</strong></td>
                                <td class="text-end valor-receita"><strong>{{ formatarMoeda(totalEntradas) }}</strong></td>
                                <td class="text-end col-pct"><strong>100,0%</strong></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                <div class="detalhes-grupo">
                    <div class="detalhes-grupo-header">
                        <span class="detalhes-categoria-nome detalhes-section-title-saidas">Saídas</span>
                        <span class="detalhes-categoria-subtotal subtotal-negativo">{{ formatarMoeda(totalSaidas) }}</span>
                    </div>
                    <table class="detalhes-table detalhes-table-resumo">
                        <thead>
                            <tr>
                                <th>Categoria</th>
                                <th class="text-end">Valor</th>
                                <th class="text-end col-pct">%</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (item of listaSaidas; track item.categoria; let i = $index) {
                            <tr class="categoria-row categoria-row-saida"
                                [class.categoria-row-expanded]="isCategoriaExpandida('saida', item.categoria)"
                                (click)="toggleCategoriaExpandida('saida', item.categoria)">
                                <td>
                                    <span class="categoria-cell-inner">
                                        <button type="button" class="btn-cat-collapse"
                                            [attr.aria-label]="isCategoriaExpandida('saida', item.categoria) ? 'Recolher' : 'Expandir'"
                                            (click)="$event.stopPropagation(); toggleCategoriaExpandida('saida', item.categoria)">
                                            <mat-icon>{{ isCategoriaExpandida('saida', item.categoria) ? 'expand_less' : 'expand_more' }}</mat-icon>
                                        </button>
                                        <span class="cat-color-dot" [style.background]="chartColor(i)"></span>
                                        {{ item.categoria }}
                                    </span>
                                </td>
                                <td class="text-end valor-despesa">{{ formatarMoeda(item.valor) }}</td>
                                <td class="text-end col-pct pct-cell">{{ item.percentual | abnt: 'quantidade': 1 }}%</td>
                            </tr>
                            @if (isCategoriaExpandida('saida', item.categoria)) {
                            <tr class="categoria-expansao-row categoria-expansao-saida" [style.--categoria-color]="chartColor(i)">
                                <td colspan="3">
                                    <table class="detalhes-table detalhes-table-drill">
                                        <thead>
                                            <tr>
                                                <th class="col-data">Data</th>
                                                <th>Descrição</th>
                                                <th class="text-end">Valor</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            @for (mov of getMovimentacoesCategoria('saida', item.categoria); track mov.idMovimentacao) {
                                            <tr>
                                                <td class="col-data">{{ formatarData(mov.dataMovimentacao) }}</td>
                                                <td class="col-descricao">{{ stripHtml(mov.descricao) }}</td>
                                                <td class="text-end col-valor valor-despesa">−{{ formatarMoeda(mov.valor) }}</td>
                                            </tr>
                                            }
                                            @if (getMovimentacoesCategoria('saida', item.categoria).length === 0) {
                                            <tr><td colspan="3" class="detalhes-empty">Sem lançamentos para esta categoria.</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            }
                            }
                            @if (listaSaidas.length === 0) {
                            <tr><td colspan="3" class="detalhes-empty">Nenhuma saída no período</td></tr>
                            }
                        </tbody>
                        <tfoot>
                            <tr>
                                <td><strong>Total de Saídas</strong></td>
                                <td class="text-end valor-despesa"><strong>{{ formatarMoeda(totalSaidas) }}</strong></td>
                                <td class="text-end col-pct"><strong>100,0%</strong></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </article>

            <!-- ── Gráficos (estilo card do Fluxo de Caixa mensal) ── -->
            <article class="tabela-card chart-card">
                <div class="chart-body">
                    <div class="chart-header-inline">
                        <div>
                            <span class="chart-title">Entradas e Saídas por Categoria (Mês)</span>
                            <span class="chart-subtitle">{{ periodoDescricaoGerado }} · Distribuição proporcional por categoria no período selecionado</span>
                        </div>
                    </div>
                    <div class="charts-row charts-row--in-card">
                        <div class="chart-panel">
                            <div class="chart-section-kicker chart-section-kicker-entradas">Distribuição de entradas</div>
                            <div class="donut-chart-box">
                                <div id="chart_entradas" class="donut-chart-area"></div>
                                <div class="donut-center-overlay">
                                    <span class="donut-center-label">TOTAL</span>
                                    <span class="donut-center-value">{{ formatarMoedaCompact(totalEntradas) }}</span>
                                </div>
                            </div>
                            <div class="chart-legend">
                                @for (item of listaEntradas; track item.categoria; let i = $index) {
                                <div class="legend-item">
                                    <span class="legend-dot" [style.background]="chartColor(i)"></span>
                                    <span class="legend-label">{{ item.categoria }}</span>
                                </div>
                                }
                            </div>
                        </div>
                        <div class="chart-panel">
                            <div class="chart-section-kicker chart-section-kicker-saidas">Distribuição de saídas</div>
                            <div class="donut-chart-box">
                                <div id="chart_saidas" class="donut-chart-area"></div>
                                <div class="donut-center-overlay">
                                    <span class="donut-center-label">TOTAL</span>
                                    <span class="donut-center-value">{{ formatarMoedaCompact(totalSaidas) }}</span>
                                </div>
                            </div>
                            <div class="chart-legend">
                                @for (item of listaSaidas; track item.categoria; let i = $index) {
                                <div class="legend-item">
                                    <span class="legend-dot" [style.background]="chartColor(i)"></span>
                                    <span class="legend-label">{{ item.categoria }}</span>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </article>

        </section>

        } @else if (consultaGerada && !possuiResultados && mensagemEmptyState) {
        <section class="empty-state-card">
            <mat-icon>search_off</mat-icon>
            <p>{{ mensagemEmptyState }}</p>
        </section>
        }

        }
    </div>
</div>
